import styled from 'styled-components';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';

export const ClearButton = styled.button`
  width: 100%;
  border-top: 1px solid #666;
  background: none;
  color: white;
  padding:
    ${spacing('3x')}
    ${spacing('3x')}
    calc(env(safe-area-inset-bottom) + ${spacing('3x')})
    ${spacing('3x')};
  cursor: pointer;
  appearance: none;
`;
